import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/mediaPlatform',
    component: LAYOUT,
    redirect: '/mediaPlatform/addressBookXzfc',
    meta: { title: '媒体平台', showNavPanel: true },
    children: [
      // {
      //   path: '',
      //   redirect: 'addressBook',
      //   meta: { title: '华联校友通讯录', hide: true },
      // },
      // {
      //   path: 'addressBook',
      //   name: '《华联校友通讯录》',
      //   component: () => import('@/views/mediaPlatform/addressBook.vue'),
      //   meta: { title: '华联校友通讯录' },
      // },
      {
        path: 'bookDetail',
        name: '华联校友通讯录详情',
        component: () => import('@/views/mediaPlatform/bookDetail.vue'),
        meta: { title: '华联校友通讯录详情', hide: true },
      },
      {
        path: 'addressBookXzfc',
        name: '《学子风采》',
        component: () => import('@/views/mediaPlatform/addressBookXzfc.vue'),
        meta: { title: '学子风采' },
      },
      {
        path: 'addressBookClub',
        name: '《社团风采》',
        component: () => import('@/views/mediaPlatform/addressBookClub.vue'),
        meta: { title: '社团风采' },
      },
      {
        path: 'subscribe',
        name: '我要订阅',
        component: () => import('@/views/mediaPlatform/subscribe.vue'),
        meta: { title: '我要订阅' },
      },
      {
        path: 'platform',
        name: '新媒体平台',
        component: () => import('@/views/mediaPlatform/platform.vue'),
        meta: { title: '新媒体平台' },
      },
    ],
  },
]
